import Language from './language';
export default {
  props: ['html', 'search', 'type'],
  components: {Language},
  data: () => ({
    row_id : -1,
    // row_position : -1,
    move_function : undefined,
    row_count : 0,
  }),
  methods: {
    getClass: function(s, i) {
      // 정규식일 경우
      // URL 일 경우
      // 문자열일 경우
      let rs = false
      switch (this.type) {
        case 'Regex':
          try { if(s.match(this.search)) { rs = true; } }
          catch (e) { rs = false; console.log(e) }
          break;
        case 'MD5':
          break;
        default:
          // string, url
          rs = (s && s.indexOf(this.search) > -1 ? true : false)
          break;
      }

      if(rs) {
        // console.log(s.match(this.search))
        this.$parent.$emit('line', i);
      }
      return { heilith : rs }
    },
    style: function(s) {
      return `padding-left:${( (s.match(/\t/gmi) || []).length * 20) + ( (s.match(' ') || []).length * 5 )}px`
    },
    clear() {
      this.move_function ? clearInterval(this.move_function) : ''; this.move_function = undefined
      console.log('clear therad')
    }
  },
  computed: {
    parsedHtml: function() {
      return this.html ? this.html.split('\n') : ''
    }
  },
  created: function() {   console.log('detect.editor.vue', 'created'); this.clear()  },
  destroyed: function() { console.log('detect.editor.vue', 'destroyed'); this.clear() },
  mounted: function() { console.log('detect.editor.vue', 'mounted'); },
};
